import * as requestFromServer from "./subscriptionPlanApis";
import Actions from "../../actions";

// subscriptions plan -> get subscriptions plan api
export const getSubscriptionPlansAction = (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getSubscriptionPlans(dataToBeSent);
    if (response) {
      setLoading(false);
      dispatch(Actions.createAction(Actions.GET_SUBSCRIPTION_PLANS_LIST, {subscriptionPlans:response}))
      return response;
    } else {
      setLoading(false)
      return null;
    }
};

// subscriptions plan -> update subscriptions plan api
export const updateSubscriptionPlanAction = (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.updateSubscriptionPlan(dataToBeSent);
    if (response) {
      setLoading(false);
      return response;
    } else {
      setLoading(false)
      return null;
    }
};